module.exports = __webpack_public_path__ + "img/twitter.c4b17ebf.svg";